/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-dock': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<g _fill="#376F99" fill-rule="nonzero"><path pid="0" d="M0 .5V7a.5.5 0 0 0 .5.5h9A.5.5 0 0 0 10 7V4.216a.5.5 0 0 0-.31-.462L.69.038A.5.5 0 0 0 0 .501zm1 .748l8 3.3v1.953H1V1.248zM9.5 8.514a.5.5 0 0 1 .09.992l-.09.008h-9a.5.5 0 0 1-.09-.991l.09-.009h9z"/></g>'
  }
})
